<style scoped>
tbody tr {
  cursor: pointer;
}

table.v-table tbody td {
  padding: 15px 24px;
}

table.v-table tbody td:last-child {
  padding: 0;
  width: 70px;
  white-space: nowrap;
}

.more-hover-btn {
  display: none;
  width: 35px;
  height: 35px;
}

span.circle {
  display: inline;
  margin-right: 10px;
  padding: 0 3px 0 3px;
}

.align-end {
  align-items: flex-end;
}

table.v-table thead td:nth-last-child(2),
table.v-table tbody td:nth-last-child(2),
table.v-table thead th:nth-last-child(2),
table.v-table tbody th:nth-last-child(2) {
  white-space: nowrap;
}

.v-icon-space {
  padding: 0 5px 0 0;
}

.theme--light.v-table tbody tr:hover .more-hover-btn,
.theme--light.v-table tbody tr:active .more-hover-btn {
  display: inline-flex;
}

.material-icons {
  display: inherit;
}
</style>

<template>
  <v-card>
    <v-layout fluid row wrap>
      <v-flex xs8 pa-4>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs4 pa-4>
        <filter-status-select
          :selectedValues="filterStatus"
          @filterChange="onFilterStatusSelectChange"
        ></filter-status-select>
      </v-flex>
      <v-flex xs12>
        <v-alert
          v-if="alert"
          :value="!isLoading"
          :type="alert.type"
          v-html="alert.message"
        ></v-alert>
        <v-data-table
          :headers="headers"
          :loading="isLoading"
          :items="getOrderItems"
          :must-sort="true"
          :search="search"
          item-key="orderLineNo"
          class="elevation-1"
          hide-actions
        >
          <template v-slot:items="props">
            <tr
              @click="props.expanded = !props.expanded"
              :class="{
                'blue-grey lighten-5 ': props.expanded
              }"
            >
              <td>
                <order-line-number
                  :value="props.item.orderLineNo"
                ></order-line-number>
              </td>
              <td>{{ props.item.materialNo }}</td>
              <td>{{ props.item.materialDescription }}</td>
              <td align="right" class="text-no-wrap">
                <!-- prettier-ignore -->
                <span class="circle blue-grey white--text elevation-2">{{ props.item.orderQuantity }}</span>
                <date-output
                  class="caption"
                  :dateString="props.item.requestedDeliveryDate"
                ></date-output>
              </td>
              <td v-if="props.item.rejectionStatus === 'C'">&nbsp;</td>
              <td v-else align="right">
                <span
                  class="text-no-wrap"
                  v-for="l in props.item.scheduleLines.filter(
                    l => l.confirmedQuantity
                  )"
                  :key="l.scheduleLineNo"
                >
                  <!-- prettier-ignore -->
                  <span class="circle light-blue white--text elevation-2">{{ l.confirmedQuantity }}</span>
                  <date-output
                    class="caption"
                    :dateString="l.deliveryDate"
                  ></date-output>
                  <br />
                </span>
              </td>
              <td align="right">
                <span
                  class="text-no-wrap"
                  v-for="l in props.item.deliveryLines.filter(
                    l => l.deliveryQuantity
                  )"
                  :key="l.deliveryLineNo"
                >
                  <order-quantity-indicator
                    :delivery-status="props.item.deliveryStatus"
                    :rejection-status="props.item.rejectionStatus"
                    :quantity="l.deliveryQuantity"
                  ></order-quantity-indicator>
                  <date-output
                    class="caption"
                    :dateString="l.plannedDeliveryDate"
                  ></date-output>
                  <br />
                </span>
              </td>

              <td>
                <order-status-indicator
                  :delivery-status="props.item.deliveryStatus"
                  :rejection-status="props.item.rejectionStatus"
                ></order-status-indicator>
              </td>
              <td>
                <v-btn
                  small
                  light
                  icon
                  fab
                  color="white"
                  class="more-hover-btn"
                >
                  <v-icon>expand_more</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expand="{ item }">
            <v-divider></v-divider>
            <v-data-iterator
              :items="item.deliveryLines.filter(l => l.deliveryQuantity)"
              row
              wrap
              hide-actions
              class="blue-grey lighten-5 elevation-12"
            >
              <template v-slot:item="{ item: deliveryLine }">
                <v-flex xs12 sm6 md4 lg3 pt-3 pb-3 pl-2 pr-2>
                  <v-card>
                    <v-card-title class="light-blue white--text">
                      <v-icon class="v-icon-space" color="white">
                        view_list
                      </v-icon>
                      <strong>
                        <div>Delivery Details</div>
                      </strong>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-list dense>
                      <v-list-tile>
                        <v-list-tile-content>
                          Delivery Note:
                        </v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          {{ deliveryLine.deliveryNo }}
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile>
                        <v-list-tile-content>
                          Delivery Date:
                        </v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          <date-output
                            :dateString="deliveryLine.realDeliveryDate"
                          />
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile v-if="deliveryLine.trackingUrl">
                        <v-list-tile-content>Tracking:</v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          <a
                            :href="deliveryLine.trackingUrl"
                            :title="'Tracking Id: ' + deliveryLine.trackingId"
                          >
                            Tracking info
                          </a>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile
                        v-if="
                          deliveryLine.invoiceLines &&
                            deliveryLine.invoiceLines.length
                        "
                        class="blue-grey lighten-5"
                        color="#444444"
                      >
                        <v-list-tile-content>Invoice Date:</v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          <date-output
                            :dateString="
                              deliveryLine.invoiceLines[0].invoiceDate
                            "
                          />
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider></v-divider>
                      <v-list-tile
                        v-if="
                          deliveryLine.invoiceLines &&
                            deliveryLine.invoiceLines.length
                        "
                      >
                        <v-list-tile-content>Invoice No:</v-list-tile-content>
                        <v-list-tile-content class="align-end">
                          {{ deliveryLine.invoiceLines[0].invoiceNo }}
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-card>
                </v-flex>
              </template>
            </v-data-iterator>
            <v-divider></v-divider>
          </template>
          <template v-slot:no-data>
            <div v-if="isLoading" style="text-align: center;">Please wait</div>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" type="error">
              Your search for "{{ search }}" has no results.
            </v-alert>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import FilterStatusSelect from "@/components/FilterStatusSelect.vue";
import OrderLineNumber from "@/components/OrderLineNumber.vue";
import OrderStatusIndicator from "@/components/OrderStatusIndicator.vue";
import OrderQuantityIndicator from "@/components/OrderQuantityIndicator.vue";
import DateOutput from "@/components/DateOutput.vue";

export default {
  name: "OrderStatusDetail",
  components: {
    FilterStatusSelect,
    OrderLineNumber,
    DateOutput,
    OrderStatusIndicator,
    OrderQuantityIndicator
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Line No.",
          value: "orderLineNo"
        },
        {
          text: "Material No.",
          value: "materialNo"
        },
        {
          text: "Description",
          value: "materialDescription"
        },
        {
          text: "Requested",
          sortable: false
        },
        {
          text: "Expected",
          sortable: false
        },
        {
          text: "Packed",
          sortable: false
        },
        {
          text: "Delivery Status",
          sortable: false
        },
        {
          text: "",
          sortable: false
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getOrderItems"]),
    ...mapGetters("customer", {
      customerId: "getCustomerId"
    }),
    alert() {
      return this.$store.state.order_status.alert;
    },
    isLoading() {
      return this.$store.state.order_status.isLoadingItems;
    },
    filterStatus() {
      return this.$store.state.order_status.filterItemStatus;
    }
  },
  watch: {
    customerId: function() {
      this.$store.dispatch("fetchOrderItems", {
        orderNo: this.$route.params.orderNo
      });
    }
  },
  methods: {
    onFilterStatusSelectChange(value) {
      this.$store.commit("setFilterItemStatus", {
        filterItemStatus: value
      });
    }
  },
  created() {
    if (this.customerId) {
      this.$store.dispatch("fetchOrderItems", {
        orderNo: this.$route.params.orderNo
      });
    }
  }
};
</script>
